import { withStyles } from "@material-ui/core/styles";
import appConstants from "../../../../../../appConstants";

const styles = (theme) => ({
  avatar: {
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.dispatchPanelHeaderColor}`,
    width: 20,
    height: 20,
    fontSize: theme.textFontSize,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "10px",
    marginRight: 8,
  },
  pickupAvatar: {
    borderRadius: "3px",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.dispatchPanelHeaderColor,
  },
  nonCompletedStop: {
    color: theme.ToggleIconColor,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.ToggleIconColor}`,
  },
});

const StopLabel = ({ stop, classes }) => {
  const isPickupStop = stop.stopType === appConstants.STOP_TYPE.Pickup;
  return (
    <div className={classes.container}>
      <div
        className={`${classes.avatar} ${
          isPickupStop ? classes.pickupAvatar : ""
        } ${stop.isStopCompleted ? "": classes.nonCompletedStop}`}
      >
        {stop.stopSequence}
      </div>
      <div>{stop.displayCustomerName}</div>
    </div>
  );
};

export default withStyles(styles)(StopLabel);
